import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F1125SchEService {

  constructor(private http: HttpClient) { }

  saveF1125Form(
    baseUrl: string, 
    formData: any[], 
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // Build jsonSettings like in original AngularJS  
    const jsonSettings = {
      "tax_year": formData[0]?.editrows?.[0]?.[0]?.tax_year || rowData.TAX_YEAR || filterParams.tax_year || '',
      "scenario": formData[0]?.editrows?.[0]?.[0]?.scenario || rowData.SCENARIO || filterParams.scenario || "",
      "jcd_key": formData[0]?.editrows?.[0]?.[0]?.jcd_key || rowData.JCD_KEY || filterParams.jcd_key || "",
      "combination_key": formData[0]?.editrows?.[0]?.[0]?.combination_key || rowData.COMBINATION_KEY || filterParams.combination_key || '',
      "trans_type_key": formData[0]?.editrows?.[0]?.[0]?.trans_type_key || '',
      "scenarioCode": rowData.SCENARIO_CODE || filterParams.scenarioCode || rowData.SCENARIO || filterParams.scenario || "",
      "is_issue_key_enabled": "N"
    };

    // Use filter parameters passed from component (replaces workspaceFactory.activeScreen.filters.getFilterParams())

    // Build payload structure exactly like in original AngularJS
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(formData) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.process_name = 'F1120_COGS';
    params.combination_key = jsonSettings.combination_key;
    params.trans_type_key = jsonSettings.trans_type_key;
    
    // CRITICAL: Add required parameters for backend validation (matching error message)
    params.tax_year = jsonSettings.tax_year || filterParams.tax_year || globalService?.globalParams?.tax_year;
    params.scenario = jsonSettings.scenario || filterParams.scenario || globalService?.globalParams?.scenario; 
    params.jcd_key = jsonSettings.jcd_key || filterParams.jcd_key || globalService?.globalParams?.jcd_key;
    params.scenarioCode = jsonSettings.scenarioCode || filterParams.scenarioCode || globalService?.globalParams?.scenarioCode || filterParams.scenario_code || "RAF";
    params.is_issue_key_enabled = filterParams.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || "N";
    
    // Add other potentially required parameters
    params.sso_id = globalService?.globalParams?.sso_id || filterParams.sso_id;
    params.screen_key = filterParams.screen_key || globalService?.globalParams?.screen_key;

    // Add checkLockedbj for lock checking
    const checkLockedbj = [{
      "leid": rowData.LEID || rowData.SOURCE_LEID || "",
      "consol_group_key": String(rowData.CONSOL_GROUP_KEY || "1"),
      "combination_key": String(rowData.COMBINATION_KEY || filterParams.combination_key || "")
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Debug: Log parameters to compare with AngularJS
    console.log('🔧 F1125SchE Save - Final params before sending:', params);
    console.log('🔧 F1125SchE Save - jsonSettings:', jsonSettings);
    console.log('🔧 F1125SchE Save - formData:', formData);

    // Convert params to URLSearchParams for form-urlencoded format (like AngularJS)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(
      `${baseUrl}/saveJsonObject?action_code=z9frws`,
      urlEncoded.toString(),
      httpOptions
    );
  }
} 